import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  onExpire?: () => void;
}
// Helper function to calculate 4-hour deadline from first visit
const getFourHourDeadline = () => {
  const now = new Date();
  const fourHoursLater = new Date(now.getTime() + 4 * 60 * 60 * 1000); // 4 hours in milliseconds
  return fourHoursLater.getTime();
};
// Helper function to calculate time left
const calculateTimeLeft = (expiryTimestamp: number) => {
  const now = new Date().getTime();
  const distance = expiryTimestamp - now;
  if (distance <= 0) {
    return {
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }
  const hours = Math.floor(distance / (1000 * 60 * 60));
  const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(distance % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
};
export function CountdownTimer({
  onExpire = () => {}
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 0,
    seconds: 0
  });
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
    // Initialize or get existing expiry time
    let expiryTime = localStorage.getItem('masterclassTimerExpiry');
    if (!expiryTime) {
      const deadline = getFourHourDeadline();
      localStorage.setItem('masterclassTimerExpiry', deadline.toString());
      expiryTime = deadline.toString();
    }
    // Set initial time immediately
    setTimeLeft(calculateTimeLeft(parseInt(expiryTime)));
    const updateTimer = () => {
      const expiryTimestamp = parseInt(expiryTime!);
      const newTimeLeft = calculateTimeLeft(expiryTimestamp);
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        onExpire();
      }
    };
    // Update every second
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [onExpire]);
  if (!isClient) {
    return <div className="text-center" data-id="element-198" data-mp="2sbogneoimkal">
        <p className="text-xl text-gray-300 mb-2 font-semibold" data-id="element-199" data-mp="2san2h1c7dhon">
          Oferta Especial Expira En:
        </p>
        <p className="text-lg text-[#06b6d4] mb-4 font-bold" data-id="element-200" data-mp="2nbtq5c8njwq2">
          Se Cierra el Carrito y los Bonos
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-201" data-mp="2ed87lh36khpa">
          <TimeUnit value={4} label="Horas" data-id="element-202" data-mp="2ef2kc84at3ia" />
          <TimeUnit value={0} label="Minutos" data-id="element-203" data-mp="29eeqzfslkakw" />
          <TimeUnit value={0} label="Segundos" data-id="element-204" data-mp="29f6hwdb91k4u" />
        </div>
      </div>;
  }
  return <div className="text-center" data-id="element-205" data-mp="24llpr1wc7kdk">
      <p className="text-xl text-gray-300 mb-2 font-semibold" data-id="element-206" data-mp="24lbxf7ntl14p">
        Oferta Especial Expira En:
      </p>
      <p className="text-lg text-[#06b6d4] mb-4 font-bold" data-id="element-207" data-mp="1vmgty3c5u553">
        Se Cierra el Carrito y los Bonos
      </p>
      <div className="flex items-center justify-center gap-4" data-id="element-208" data-mp="1qn45xf9jys0x">
        <TimeUnit value={timeLeft.hours} label="Horas" data-id="element-209" data-mp="1qpgkrjk0km9r" />
        <TimeUnit value={timeLeft.minutes} label="Minutos" data-id="element-210" data-mp="1lpc33q7ddlhy" />
        <TimeUnit value={timeLeft.seconds} label="Segundos" data-id="element-211" data-mp="168nbpgmqmbu" />
      </div>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-212" data-mp="63i9mw8q2hvg">
      <div className="bg-gradient-to-br from-[#06b6d4] to-[#0891b2] rounded-lg w-20 h-20 flex items-center justify-center text-3xl font-bold shadow-lg" data-id="element-213" data-mp="b3wk0kxsq3wn">
        {value.toString().padStart(2, '0')}
      </div>
      <span className="text-sm text-gray-400 mt-2 font-medium" data-id="element-214" data-mp="3elxwx8i4e4to">{label}</span>
    </div>;
}